import React from "react";

const Projects: React.FC = () => {
  const portfolioItems = [
    {
      id: 12,
      title: "N2TTFA (Nitrogen Tires From Free Air)",
      category: "Engineering | IoT",
      image: "/assets/img/portfolio/nitrogen.jpeg",
      url: "",
      hasGithubLink: false,
      description:
        "A prototype system that auto-inflates tires with nitrogen to reduce blowout risk in extreme heat. Uses membrane filtration, TPMS feedback, and airflow control for real-time pressure stability.",
    },
    {
      id: 11,
      title: "Ticket Management System",
      category: "Python | CLI | MySQL",
      image: "/assets/img/portfolio/ticket.jpeg",
      url: "https://github.com/sibi15/Ticket-Management-System",
      hasGithubLink: true,
      description:
        "A CLI-based ticket management system built with Python and MySQL for parking operations. Features automated ticket ID generation, precise time tracking using system counters, and dynamic fee calculation integrated with a relational database backend.",
    },
    {
      id: 10,
      title: "xG Model for Match Outcome Prediction",
      category: "Football | Simulation",
      image: "/assets/img/portfolio/xg.jpeg",
      url: "https://github.com/sibi15/xG-Model-for-Match-Outcome-Prediction",
      hasGithubLink: true,
      description:
        "Football match outcome predictor using xG values per shot. Simulates 10,000 games to estimate home win, away win, and draw probabilities using random-based goal simulation.",
    },
    {
      id: 9,
      title: "Netflix Clone",
      category: "Frontend | Web",
      image: "/assets/img/portfolio/netflix.jpeg",
      url: "https://github.com/sibi15/Netflix-Clone",
      hasGithubLink: true,
      description:
        "A responsive front-end replica of Netflix's homepage built with HTML, CSS, and JavaScript. Demonstrates responsive design principles, component-based styling, and modern web development practices with deployment via Vercel for production-ready hosting.",
    },
    {
      id: 8,
      title: "Telegram Joke Chatbot",
      category: "AI | Chatbot",
      image: "/assets/img/portfolio/chatbot.jpeg",
      url: "https://github.com/sibi15/Telegram-Joke-Chatbot",
      hasGithubLink: true,
      description:
        "An intelligent chatbot integrated with Telegram using LangChain and LLMs (Groq API) for real-time conversation. Demonstrates API integration, LLM prompt engineering, and deployment of AI-powered conversational interfaces.",
    },
    {
      id: 7,
      title: "EPL 2020/21 Seasons Analysis",
      category: "Football | Analytics",
      image: "/assets/img/portfolio/pl.jpeg",
      url: "https://github.com/sibi15/EPL-2020-21-Analysis",
      hasGithubLink: true,
      description:
        "This project analyzes English Premier League 2020/21 data to uncover team performance, player statistics, and match outcome trends, highlighting key factors for success.",
    },
    {
      id: 6,
      title: "Sequence Generator",
      category: "Math | Python App",
      image: "/assets/img/portfolio/sequence.jpg",
      url: "https://github.com/sibi15/Sequence-Generator",
      hasGithubLink: true,
      description:
        "Python project showcasing six classic number sequences with text-to-speech narration, user feedback logging (MySQL/CSV), and session transcript emails. A digital museum for math enthusiasts and educators alike.",
    },
    {
      id: 5,
      title: "EFL 2023/24 Prediction Model",
      category: "Football | Data Modelling",
      image: "/assets/img/portfolio/2023-24.jpeg",
      url: "https://github.com/sibi15/2023-24-EFL-Prediction",
      hasGithubLink: true,
      description:
        "A Python data analysis project that applies the Pythagorean Expectation model to predict 2023/24 EFL Championship standings. Uses Pandas, NumPy, and StatsModels to process multi-season data, calculate expected points, and validate predictions against real results.",
    },
    {
      id: 4,
      title: "Automated Vehicle Damage Detection System",
      category: "Computer Vision | Insurance",
      image: "/assets/img/portfolio/vehicle.jpeg",
      url: "https://github.com/sibi15/ML-Vehicle-Damage-Detection-System-for-Insurance-Claims",
      hasGithubLink: true,
      description:
        "A machine learning pipeline built with TensorFlow and OpenCV for detecting vehicle damage in insurance claims. Uses CNNs to identify dents, scratches, and broken parts with over 93% accuracy.",
    },
    {
      id: 3,
      title: "Cloud Health Diagnostics",
      category: "Healthcare AI | Cloud",
      image: "/assets/img/portfolio/cloud.webp",
      url: "https://github.com/sibi15/Cloud-Health-Diagnostics",
      hasGithubLink: true,
      description:
        "Cloud-based AI tool deployed using AWS SageMaker for early-stage diagnosis using medical scans. Classifies scan type, runs deep learning models (CNNs, DenseNet, ResNet, VGG), and delivers predictions with up to 83% accuracy.",
    },
    {
      id: 2,
      title: "Oil Spill Detection using Computer Vision",
      category: "Computer Vision | Web App",
      image: "/assets/img/portfolio/oil.jpeg",
      url: "https://github.com/sibi15/Oil-Spill-Detection-using-Computer-Vision",
      hasGithubLink: true,
      description:
        "Deep learning–powered full-stack web app for oil spill detection in SAR satellite imagery. Built with React, Flask, TensorFlow, and OpenCV. Real-time segmentation with visual metrics and environmental impact analysis.",
    },
    {
      id: 1,
      title: "TactiTrack",
      category: "Deep Learning | Football",
      image: "/assets/img/portfolio/tactitrack.jpeg",
      url: "https://github.com/sibi15/TactiTrack",
      hasGithubLink: true,
      description:
        "Deep learning pipeline for football video analysis using YOLOv8, Roboflow, and OpenCV. Detects and tracks players and the ball, computes tactical metrics, and applies perspective correction for spatial accuracy.",
    },
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <div className="section-title" data-aos="fade-up">
          {/* Removed Projects heading for cleaner look */}
        </div>

        <div
          className="row projects-container"
          data-aos="fade-up"
          data-aos-delay="200"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 24,
            justifyContent: "center",
          }}
        >
          {[...portfolioItems].reverse().map((item) => (
            <div
              className="col-lg-6 col-md-6 projects-item"
              key={item.id}
              style={{
                minWidth: 300,
                maxWidth: 420,
                flex: "1 1 320px",
                margin: "0 auto",
                marginBottom: 32,
              }}
            >
              <div
                className="projects-wrap"
                style={{
                  borderRadius: 16,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                  background: "#fff",
                  padding: 16,
                }}
              >
                <div
                  className="projects-image-container"
                  style={{
                    textAlign: "center",
                    marginBottom: 16,
                    position: "relative",
                  }}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="projects-img"
                    style={{
                      borderRadius: 8,
                      width: "100%",
                      height: 180,
                      objectFit: "cover",
                    }}
                  />
                  {item.hasGithubLink && item.url && item.url.trim() !== "" && (
                    <a
                      href={item.url}
                      className="github-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        color: "#222",
                      }}
                    >
                      <i className="bi bi-github" style={{ fontSize: 22 }}></i>
                    </a>
                  )}
                </div>
                <div className="projects-info" style={{ textAlign: "center" }}>
                  <h4 style={{ marginBottom: 8 }}>{item.title}</h4>
                  <p
                    style={{
                      fontWeight: 500,
                      color: "#666",
                      marginBottom: 8,
                      fontStyle: "italic",
                    }}
                  >
                    {item.category}
                  </p>
                  <p
                    className="projects-description"
                    style={{ fontSize: "1rem", color: "#444" }}
                  >
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
